import { sanitizeHTML } from "@/lib/utils";
import Link from "next/link";

interface BookYourConsultationData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
}

export const fields = [
  // headings
  "heading.text",
  "heading.title",

  // text
  "text.text",

  // buttons
  "button.label",
  "button.href",
] as const;

interface BookYourConsultationProps {
  data?: BookYourConsultationData;
}

export default function BookYourConsultation({ data }: BookYourConsultationProps) {
  return (
    <section className="w-full bg-primary">
      <div className="container mx-auto px-8 py-8 xl:py-16">
        <div className="w-full max-w-screen-lg mx-auto">
          {/* Heading */}
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-white text-center pb-8">
            {data?.heading?.title}
          </h2>

          {/* Description */}
          <div 
            className="text-center text-white md:text-xl text-[1rem] font-normal font-greycliff md:leading-7 leading-normal tracking-tight pb-8 [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal md:[&>*]:text-xl md:[&>*]:leading-7"
            dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || "")}
          />

          {/* CTA Button */}
          <div className="text-center">
            {data?.button?.href && data?.button?.label && (
              <Link href={data.button.href || "#"} className="inline-block px-12 py-5 bg-light rounded-full">
                <span className="text-primary text-xl font-normal font-greycliff leading-7 tracking-tight">
                  {data.button.label}
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
} 